<template>
  <div class="integration">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">System Integration</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <!-- PC -->
          <v-tabs class="d-none d-sm-block" grow v-model="tabs">
            <v-tab href="#tab-1">ERP, DW, CRM, MES 시스템 구축</v-tab>
            <v-tab href="#tab-2">Enterprise Portal 시스템 구축</v-tab>
            <v-tab href="#tab-3">차세대 웹표준 시스템 구축</v-tab>
          </v-tabs>
          
          <!-- mobile -->
          <v-tabs class="d-sm-none mob" grow vertical v-model="tabs">
            <v-tab href="#tab-1">ERP, DW, CRM, MES 시스템 구축</v-tab>
            <v-tab href="#tab-2">Enterprise Portal 시스템 구축</v-tab>
            <v-tab href="#tab-3">차세대 웹표준 시스템 구축</v-tab>
          </v-tabs>

          <!-- image cache loading -->
          <img src="@/assets/img_sub_ser_Integration01.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_Integration02.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_Integration03.svg" style="display:none; " />

          <v-tabs-items v-model="tabs" class="mt-10">
            <v-tab-item value="tab-1">
              <v-sheet width="100%" class="d-flex">
                <img src="@/assets/img_sub_ser_Integration01.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">ERP, DW, CRM, MES 시스템 구축</dt>
                <dd class="px-4">고객의 산업별, 기능별 최적화된 통합 ICT 시스템 개발로<br class="d-none d-sm-block">고객의 가치 창출과 성장 지원.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-sheet width="100%" class="d-flex">
                <img src="@/assets/img_sub_ser_Integration02.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">Enterprise Portal 시스템 구축</dt>
                <dd class="px-4">기업형 Enterprise Portal 구축이며,<br>다양한 Vendor 제품을 이용한 구축 경험 및 컨설팅 Knowhow를 보유.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-sheet width="100%" class="d-flex">
                <img src="@/assets/img_sub_ser_Integration03.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">차세대 웹표준 시스템 구축</dt>
                <dd class="px-4">차세대 포탈 구축에 적용하여 현재 프로젝트 진행 중.</dd>
              </dl>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'integration',
  data() {
    return {
      tabs: null,
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".integration .sub-body-title", {
      scrollTrigger: {
        trigger: ".integration .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".integration .sub-body-content", {
      scrollTrigger: {
        trigger: ".integration .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>